exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.iframe-container[data-v-2dd11540] {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n}\n.iframe-content[data-v-2dd11540] {\n  width: 100%;\n  height: 100%;\n  border: none;\n  display: block;\n}\n#Return_Bar[data-v-2dd11540] {\n  padding-left: 21px;\n  display: flex;\n  padding-top: 10px;\n  padding-bottom: 15px;\n  width: 100%;\n}\n[data-v-2dd11540] .el-icon-arrow-left {\n  margin-top: 5px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2dd11540","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/train/FBT/trainResult.vue
// module id = 1759
// module chunks = 0